import type { AppRecord } from '../../lib/types';
import { getAppStatusBadge, type CompassLocale } from '../i18n';

export function statusBadge(app: AppRecord, locale: CompassLocale): { color: string; label: string } {
  return getAppStatusBadge(app.appClass, app.statuses.pipelineStatus, locale);
}
